// ═══════════════════════════════════════════════════════════════
// VERSION CONSTANTS
// Single source of truth for the running build's version and the
// storage keys / URLs used by the new-version detection system.
// `__APP_VERSION__` is injected at build time by vite.config.ts
// (from Netlify's COMMIT_REF, or a local-<timestamp> fallback).
// ═══════════════════════════════════════════════════════════════

export const APP_VERSION: string =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';

/** localStorage key holding the version that last ran its clean-first-run reset. */
export const APP_VERSION_LS_KEY = 'mos:app-version';

/** sessionStorage one-shot guard so a failed chunk reloads at most once per tab. */
export const CHUNK_RELOAD_GUARD_KEY = 'mos:chunk-reloaded';

/** Static manifest emitted into the build; fetched at runtime to detect new deploys. */
export const VERSION_MANIFEST_URL = '/version.json';

/** One shipped commit: `v` = short sha (matches APP_VERSION), `n` = its note ('' = don't show). */
export interface VersionChange {
  v: string;
  n: string;
}

export interface VersionManifest {
  version: string;
  builtAt: string;
  /** Headline for this deploy alone. Legacy — clients now read `changes`. */
  note?: string;
  /** Recent commits, newest first, so a client can list everything since its own build. */
  changes?: VersionChange[];
}
